module.exports = __webpack_public_path__ + "img/plcconfig_qushitu.03d32367.png";